/* eslint-disable react/react-in-jsx-scope */
import { Box } from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { caseManagementUrl } from "../../../../config";
import FactsForm from "./Form";
import {
  FactColumns,
} from "../../../../data/DynamicTable/Collumns";
import { useEffect, useState } from "react";
import { fetchDataEngine } from "../../../../data/Axios/DynamicService";

const base_url = caseManagementUrl.uri;
const caseIdFromSession = JSON.parse(localStorage.getItem("CaseId"));
const actions = {
  entity: "Fact Recording",
  isSubRight: false,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  ViewCase: {
    key: "VIEWDETAILS",
    button_name: "View Details",
    Show_Button: false,
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  showStatus: true,
  dataObject: {
    inputObjectName: "allFactsByColumnValues",
    inputSubObjectName: "factModel",
    inputFields: {
      caseId: caseIdFromSession,
    },
    returnFields: ["id", "factDescription", "courtDate", "courtId"], // Added courtId
  },
};
function CaseFacts() {
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Facts"
          subtitle="View all Facts related to a case, create or edit a fact"
          columns={FactColumns}
          FormComponent={FactsForm}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default CaseFacts;